import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { EntradaService } from '../../../_services';
import { AuthenticationService } from '../../../_services';
import { ShowEntrada, InboundEvent, EntradaShowResponseBody, InboundEventsResponseBody } from '../entradas.component';

const mexicoCityDateTimeFormatter = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

const mexicoCityDateFormatter = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

const mexicoCityTimeFormatter = new Intl.DateTimeFormat('es-MX', {
  timeZone: 'America/Mexico_City',
  hour: '2-digit',
  minute: '2-digit',
});

@Component({
  selector: 'app-ver-orden-entrada',
  templateUrl: './ver-orden-entrada.component.html',
  styleUrls: ['../entradas.component.scss'],
})
export class VerOrdenEntradaComponent implements OnInit {

  params: EntradaShowResponseBody | null = null;
  usuario: string;
  datos_tabla: ShowEntrada[] = [];
  datos_tabla_historial: InboundEvent[] = [];
  displayedColumns = [
    'titulo', 'seller_sku', 'ean', 'upc',
    'cantidad_anunciada', 'cantidad_recibida', 'presale_stock',
    'cantidad_aceptada', 'cantidad_rechazada',
  ];
  displayedColumnsHistorial = ['fecha_evento', 'status', 'substatus', 'description'];
  progress = false;
  descargar = false;
  entrada_token: string;
  url_descargar = '';
  current_user: any;
  cargando = true;
  cancelando = false;
  comentarioCancelacion = '';
  cancelacionError = '';
  cancelacionDialogRef: any = null;

  // --- Dialog de evidencias ---
  evidenciaDialogData: any = null;
  evidenciaDialogTipo: 'rechazo' | 'aceptado' = 'rechazo';
  @ViewChild('evidenciaDialogTemplate', { static: false }) evidenciaDialogTemplate: TemplateRef<any>;
  @ViewChild('cancelacionDialogTemplate', { static: false }) cancelacionDialogTemplate: TemplateRef<any>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private entradaService: EntradaService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.asignarDatos();
    this.entrada_token = this.route.snapshot.paramMap.get('token');
    if (this.entrada_token) {
      this.cargarEntrada();
    } else {
      this.cargando = false;
    }
  }

  asignarDatos() {
    this.current_user = this.authenticationService.currentUserValue;
    this.authenticationService.currentUser.subscribe(x => this.usuario = x);
    if (this.usuario) {
      this.usuario = this.usuario['seller_id'];
    }
  }

  validar_roles(clave_modulo) {
    return this.authenticationService.validar_roles(clave_modulo, this.current_user.permisos);
  }

  cargarEntrada() {
    this.cargando = true;
    this.entradaService.consultarEntrada(this.entrada_token)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200) {
            this.params = data.body as EntradaShowResponseBody;
            this.datos_tabla = this.params.esta_entrada;
            this.datos_tabla = this.datos_tabla.filter(value => value);
          }
          this.cargando = false;
          this.cargarHistorialEventos();
        },
        error => {
          this.cargando = false;
        }
      );
  }

  cargarHistorialEventos() {
    this.entradaService.consultarInboundEvents(this.entrada_token)
      .pipe(first())
      .subscribe(
        data => {
          const body = data.body as InboundEventsResponseBody;
          if (data.status === 200 && body.inbound_events) {
            this.datos_tabla_historial = body.inbound_events;
          }
        },
        error => {
          console.error('Error al cargar historial de eventos:', error);
        }
      );
  }

  puedeCancelar(): boolean {
    const entradaList = this.params && this.params.entrada_list ? this.params.entrada_list : null;
    const status = entradaList && entradaList.status ? String(entradaList.status).toUpperCase() : '';
    return !!(entradaList && entradaList.cancelable) &&
      status === 'AGENDADO' &&
      this.validar_roles('4entradas') &&
      !this.cancelando;
  }

  cancelarEntrada() {
    if (!this.puedeCancelar()) {
      return;
    }

    this.comentarioCancelacion = '';
    this.cancelacionError = '';
    this.cancelacionDialogRef = this.dialog.open(this.cancelacionDialogTemplate, {
      width: '560px',
      maxWidth: '95vw',
      disableClose: true,
      panelClass: 'cancelacion-entrada-dialog-panel'
    });
  }

  cerrarDialogoCancelacion() {
    this.cancelacionError = '';
    this.comentarioCancelacion = '';
    if (this.cancelacionDialogRef) {
      this.cancelacionDialogRef.close();
      this.cancelacionDialogRef = null;
    }
  }

  confirmarCancelacionEntrada() {
    const comentarioLimpio = (this.comentarioCancelacion || '').trim();
    if (!comentarioLimpio) {
      this.cancelacionError = this.translate.instant('entradas.cancelacion_comentario_requerido');
      return;
    }

    this.cancelando = true;
    this.cancelacionError = '';
    this.entradaService.cancelarEntrada(this.entrada_token, comentarioLimpio)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200) {
            this.cerrarDialogoCancelacion();
            this.cargarEntrada();
          }
          this.cancelando = false;
        },
        error => {
          let mensaje = this.translate.instant('entradas.cancelacion_error');
          if (error && error.error && error.error.message) {
            mensaje = error.error.message;
          }
          this.cancelacionError = mensaje;
          this.cancelando = false;
        }
      );
  }

  generarEtiqueta() {
    this.progress = true;
    this.entradaService.generarEtiqueta(this.entrada_token)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200) {
            this.consultarStatusEtiqueta(this.entrada_token);
          }
        },
        error => {}
      );
  }

  consultarStatusEtiqueta(entrada_token: string) {
    this.entradaService.consultarEtiquetas(entrada_token)
      .pipe(first())
      .subscribe(
        data => {
          if (data.status === 200) {
            if (data.body['result'] === 200) {
              this.url_descargar = data.body['url_descargar'];
              this.progress = false;
              this.descargar = true;
            } else {
              setTimeout(() => {
                this.consultarStatusEtiqueta(entrada_token);
              }, 3000);
            }
          }
        },
        error => {}
      );
  }

  getTotalCantAnun() {
    return this.datos_tabla.map(t => t.cantidad_anunciada).reduce((acc, value) => acc + value, 0);
  }

  getTotalCantRec() {
    return this.datos_tabla.map(t => t.cantidad_recibida).reduce((acc, value) => acc + value, 0);
  }

  getTotalCantAceptada() {
    return this.datos_tabla
      .map(t => (t as any).checking_quantity_accepted || 0)
      .reduce((acc, value) => acc + value, 0);
  }

  getTotalCantRechazada() {
    return this.datos_tabla
      .map(t => (t as any).checking_quantity_rejected || 0)
      .reduce((acc, value) => acc + value, 0);
  }

  tieneEvidenciasRechazo(row: any): boolean {
    const evidencias = this.parseEvidencias(row.evidencias_checking);
    return evidencias.length > 0;
  }

  tieneEvidenciasAceptado(row: any): boolean {
    const evidencias = this.parseEvidencias(row.evidencias_aceptado);
    return evidencias.length > 0 || !!row.motivo_aceptado;
  }

  verEvidenciasRechazo(row: any) {
    this.evidenciaDialogData = {
      ...row,
      evidencias_checking: this.parseEvidencias(row.evidencias_checking),
    };
    this.evidenciaDialogTipo = 'rechazo';
    this.dialog.open(this.evidenciaDialogTemplate, { width: '640px', maxHeight: '85vh' });
  }

  verEvidenciasAceptado(row: any) {
    this.evidenciaDialogData = {
      ...row,
      evidencias_aceptado: this.parseEvidencias(row.evidencias_aceptado),
    };
    this.evidenciaDialogTipo = 'aceptado';
    this.dialog.open(this.evidenciaDialogTemplate, { width: '640px', maxHeight: '85vh' });
  }

  getUrlEvidencia(ev: any): string {
    return ev.file_url || ev.file_ulr || ev.url || '';
  }

  /** Normaliza el campo evidencias: puede venir como string JSON o como array */
  private parseEvidencias(value: any): any[] {
    if (!value) { return []; }
    if (Array.isArray(value)) { return value; }
    if (typeof value === 'string') {
      try { return JSON.parse(value) || []; } catch { return []; }
    }
    return [];
  }

  getTotalPreventa() {
    return this.datos_tabla.map(t => (t as any).presale_stock || 0).reduce((acc, value) => acc + value, 0);
  }

  formatMexicoDateTime(value?: string | null): string {
    if (!value) {
      return '—';
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    return mexicoCityDateTimeFormatter.format(parsed);
  }

  formatMexicoDate(value?: string | null): string {
    if (!value) {
      return '—';
    }

    const dateMatch = String(value).match(/(\d{4})-(\d{2})-(\d{2})/);
    if (dateMatch) {
      return `${dateMatch[3]}/${dateMatch[2]}/${dateMatch[1]}`;
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      return value;
    }

    return mexicoCityDateFormatter.format(parsed);
  }

  formatMexicoTime(value?: string | null): string {
    if (!value) {
      return '—';
    }

    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) {
      const timeMatch = String(value).match(/(?:T|\b)(\d{2}:\d{2})(?::\d{2})?/);
      return timeMatch ? timeMatch[1] : value;
    }

    return mexicoCityTimeFormatter.format(parsed);
  }

  volver() {
    this.router.navigate(['/entradas']);
  }
}
